/*!

=========================================================
* Material Kit PRO React - v1.10.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui icons
import Business from "@material-ui/icons/Business";
// core components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";

import cardsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/sectionCards.js";

const style = {
  ...cardsStyle,
};

const useStyles = makeStyles(style);

export default function CardExampleCardPricing() {
  const classes = useStyles();
  return (
    <Card pricing color="primary" style={{ maxWidth: "235px" }}>
      <CardBody pricing>
        <div className={`${classes.iconWrapper} ${classes.iconWrapperColor}`}>
          <Business className={classes.iconWhite} />
        </div>
        <h3 className={`${classes.cardTitleWhite} ${classes.marginTop30}`}>
          $69
        </h3>
        <p className={classes.cardDescriptionWhite}>
          This is good if your company size is between 11 and 99 Persons.
        </p>
        <Button round color="white">
          Choose plan
        </Button>
      </CardBody>
    </Card>
  );
}
